import { CreateSchoolDocument } from "@pathwright/graphql-client/src/generated"

export default CreateSchoolDocument
